import React from "react";
import styled from "styled-components";
import { PhoenixIcon } from "..";
import { AppText, FlexDiv } from "../../../UI";
import { theme } from "../../../../utils/theme";
import {
  user as LeadIcon,
  record as RecordIcon,
  book as CoachingIcon,
  bell as NotificationsIcon,
  message_square as MessageIcon,
  phone_call as TranscriptIcon,
  bar_chart as DataIcon,
  users as LeadsIcon,
  info as InfoIcon,
  video as ScreensharingIcon,
  file_text as NoteIcon,
  chat as ChatIcon,
  mail as MailIcon,
  sequences as SequencesIcon,
  search as SearchIcon,
  calendar as HistoryIcon,
  folder as FolderIcon,
  list as listIcon,
} from "../../../../images/NewDesign";

type PhoenixEmptyStateIconType =
  | "history"
  | "lead"
  | "record"
  | "coaching"
  | "notifications"
  | "message"
  | "transcript"
  | "folder"
  | "data"
  | "leads"
  | "info"
  | "screensharing"
  | "note"
  | "chat"
  | "mail"
  | "sequences"
  | "search"
  | "list";

interface PhoenixEmptyStateProps {
  // Required props
  text: string;
  iconType: PhoenixEmptyStateIconType;

  // Optional content
  subtext?: string;

  // Style overrides
  textColor?: string;
  subtextColor?: string;
  iconColor?: string;
  iconSize?: number;
  button?: React.ReactNode;
}

const PhoenixEmptyState: React.FC<PhoenixEmptyStateProps> = ({
  // Required props
  text,
  iconType = "info",

  // Optional content
  subtext,
  button,

  // Style overrides
  textColor = theme.text.neutral.tertiary,
  subtextColor = theme.text.neutral.tertiary,
  iconColor = theme.icon.neutral.default,
  iconSize = 40,
}) => {
  const icon = getIconFromType(iconType);

  return (
    <Main>
      <PhoenixIcon svg={icon} size={iconSize} color={iconColor} hoverColor={iconColor} />
      <FlexDiv width="100%" align="center" justify="center" direction="column" gap={4}>
        <AppText color={textColor} fontSize={14} fontWeight={400} lineHeight={20} textAlign="center">
          {text}
        </AppText>
        {subtext && (
          <AppText color={subtextColor} fontSize={14} fontWeight={400} lineHeight={20} textAlign="center">
            {subtext}
          </AppText>
        )}
      </FlexDiv>
      {button && <FlexDiv>{button}</FlexDiv>}
    </Main>
  );
};

const getIconFromType = (type: PhoenixEmptyStateIconType) => {
  switch (type) {
    case "history":
      return HistoryIcon;
    case "lead":
      return LeadIcon;
    case "record":
      return RecordIcon;
    case "coaching":
      return CoachingIcon;
    case "notifications":
      return NotificationsIcon;
    case "message":
      return MessageIcon;
    case "transcript":
      return TranscriptIcon;
    case "data":
      return DataIcon;
    case "leads":
      return LeadsIcon;
    case "info":
      return InfoIcon;
    case "screensharing":
      return ScreensharingIcon;
    case "note":
      return NoteIcon;
    case "chat":
      return ChatIcon;
    case "mail":
      return MailIcon;
    case "sequences":
      return SequencesIcon;
    case "search":
      return SearchIcon;
    case "folder":
      return FolderIcon;
    case "list":
      return listIcon;
    default:
      return InfoIcon;
  }
};

const Main = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  min-width: 262px;
  height: max-content;
  margin: 0 auto;
  text-align: center;
`;

export default PhoenixEmptyState;
